import { render, staticRenderFns } from "./gcs.vue?vue&type=template&id=3a16bf47&scoped=true&"
import script from "./gcs.vue?vue&type=script&lang=js&"
export * from "./gcs.vue?vue&type=script&lang=js&"
import style0 from "./gcs.vue?vue&type=style&index=0&id=3a16bf47&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a16bf47",
  null
  
)

export default component.exports